// Dependencies
import { useState, useEffect, useRef, useCallback, useMemo, useContext } from "react";
import { ReactSVG } from "react-svg";
import _ from "lodash";

// Types
import { Types, Components } from '../types';

// Utils
import { getAssetURL } from '../utils/helpers'

// Hooks
import { useDebug } from "../hooks";

// Contexts
//import AppContext from "../contexts/AppContext";

// Components 
import Price from "./Price";
import { QuantitySelect } from "./Product/QuantitySelect";
import Overlay from "./Overlay";
import { MinicartContext } from "../contexts/Minicart";

const CartItem = ({cartItemID, productID, image, name, isUpdating, quantity, subtotal, attributes, type, price, pricePerUnit, className, bundledBy, permalink, ...props}: any) => {
    useDebug('CartItem'); 

    const { loading, opened, items, itemsCount, itemsSubtotal, toggleState, config, translations, theme, handleItemRemove, handleItemUpdate } = useContext( MinicartContext );

    // Helpers
    // const getFormattedAttributesList = () => attributes?.map((attribute: Types.ProductAttribute) => attribute.value.label).join(', '); // 
    const getFormattedAttributesList = () => Object.values(attributes).join(', '); // 

     
    return (
        <div className={`${className} ${_.isEmpty(bundledBy) ? type : 'bundled-item'}`}>  
            <img src={image.feature} alt={name} className={`${className}__image`}/>
            <div className={`${className}__meta`}>
                
                <a href={permalink} target="_blank" rel="noreferrer" className={`${className}__name`}>{name}</a>
                { ( type === 'variation' && ! _.isEmpty( attributes ) ) && <small className={`${className}__attributes`}>{getFormattedAttributesList()}</small> }
            </div>
            {
                _.isEmpty(bundledBy) && (<>
                    <ReactSVG
                        tabIndex={0}
                        role="button"
                        fill="#000"
                        className={`${className}__remove`} 
                        src={getAssetURL('icon', 'cross')}
                        onClick={() => handleItemRemove({cartItemID})} 
                    />
                    <QuantitySelect 
                        quantity={quantity} 
                        onChange={(newQuantity: number) => handleItemUpdate({name: 'quantity', value: newQuantity, cartItemID})}  
                    />
                    <div className={`${className}--subtotal`}>
                        <Price value={pricePerUnit} className={[`${className}--subtotal__per-unit`]} 
                            {...{ loading }}
                            {...{config, translations, theme}}
                        />
                        {/* <QuantitySelect className={`${className}`} min={1} max={99} quantity={quantity} onChange={handleQuantityUpdate} /> */}
                        <Price value={subtotal} className={[`${className}--subtotal__total`]}  {...{ loading }} {...{config, translations, theme}}/>
                    </div>
                </>)
            }
        </div>
    ) 
}

export default CartItem; 